<template>
	<div v-if="widget" class="widget">

		<template v-if="widget.setup">

			<MediaWidget
				v-if="widget.id === 'MEDIA'"
				:widget="widget"
			/>
			<WebpageWidget
				v-if="widget.id === 'WEBPAGE'"
				:widget="widget"
			/>
			<TextWidget
				v-if="widget.id === 'TEXT'"
				:widget="widget"
			/>
			<MarqueeWidget
				v-if="widget.id === 'MARQUEE'"
				:widget="widget"
			/>
			<WeatherWidget
				v-if="widget.id === 'WEATHER'"
				:widget="widget"
			/>
			<CountdownWidget
				v-if="widget.id === 'COUNTDOWN'"
				:widget="widget"
			/>
			<QRcodeWidget
				v-if="widget.id === 'QRCODE'"
				:widget="widget"
			/>
			<YoutubeWidget
				v-if="widget.id === 'YOUTUBE'"
				:widget="widget"
			/>
			<GoogleMapsWidget
				v-if="widget.id === 'GOOGLEMAPS'"
				:widget="widget"
			/>
			<DateWidget
				v-if="widget.id === 'DATE'"
				:widget="widget"
			/>

		</template>

		<div v-else class="widget-empty">

			<div class="widget-empty-content">
				<i class="el-icon-warning-outline" />
				<div class="widget-empty-text">
					{{ translations.messages.widgetNotSet }}
				</div>
			</div>

		</div>

	</div>
</template>

<script>
export default {
    name: 'Widgets',
	components: {
		DateWidget: () => import( /* webpackPrefetch: true */ '@/views/Private/Components/Widgets/Date/View'),
		GoogleMapsWidget: () => import( /* webpackPrefetch: true */ '@/views/Private/Components/Widgets/GoogleMaps/View'),
		WebpageWidget: () => import( /* webpackPrefetch: true */ '@/views/Private/Components/Widgets/Webpage/View'),
		MarqueeWidget: () => import( /* webpackPrefetch: true */ '@/views/Private/Components/Widgets/Marquee/View'),
		WeatherWidget: () => import( /* webpackPrefetch: true */ '@/views/Private/Components/Widgets/Weather/View'),
		CountdownWidget: () => import( /* webpackPrefetch: true */ '@/views/Private/Components/Widgets/Countdown/View'),
		QRcodeWidget: () => import( /* webpackPrefetch: true */ '@/views/Private/Components/Widgets/QRcode/View'),
		MediaWidget: () => import( /* webpackPrefetch: true */ '@/views/Private/Components/Widgets/Media/View'),
		TextWidget: () => import( /* webpackPrefetch: true */ '@/views/Private/Components/Widgets/Text/View'),
		YoutubeWidget: () => import( /* webpackPrefetch: true */ '@/views/Private/Components/Widgets/Youtube/View'),
	},
	props: {
		widget: Object
	}
}
</script>

<style lang="scss" scoped>

.widget {

	@include flex(flex, row, wrap, center, center);
	height: 100%;
	position: relative;
	width: 100%;

	&-empty,
	&-preview {
		height: 100%;
		position: relative;
		width: 100%;
	}

	&-preview {

		user-select: none;

		&:after {
			content: '';
			height: 100%;
			@include position($position: fixed, $top: 0, $left: 0);
			width: 100%;
			z-index: 1000;
		}

	}

	&-empty {

		background-color: darken($color-background, 1%);
		@include flex(flex, row, wrap, center, center);
		user-select: none;

		&-content {

			color: lighten($color-text, 20%);
			text-align: center;

			&-text {
				font-size: $font-size + 2;
				font-weight: $font-weight-medium;
				text-transform: uppercase;
				width: 100%;
			}

			[class^="el-icon-"],
			[class*=" el-icon-"] {
				color: lighten($color-text, 30%);
				font-size: 44px;
				margin-bottom: 20px;
			}

		}

	}

}

</style>
